var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoMargheritaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 276,
    viewBox: "0 0 274 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 274,
    height: 276
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 276,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.75 168.476L95.7613 205.734L51 292.566",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.269 228.022L119.101 240.487L92.4975 299.866",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.333 192.196L188.085 177.434",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.121 196.577L207.32 185.683",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.473 209.22L208.265 197.389",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.536 218.627L202.523 212.651",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.027 137.979L157.353 154.035L53.3819 123.702L63.5904 88.7006L156.265 72.6446L260.236 102.978L250.027 137.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5747 92.7724L167.812 119.186L260.228 103.056",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.838 119.189L159.593 148.98",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoMargheritaIcon);
export default __webpack_public_path__ + "static/media/promo-margherita-icon.4bca7aba77581b2d1ccf3e45182b7576.svg";
export { ForwardRef as ReactComponent };